module.exports = __webpack_public_path__ + "media/points_re/money-cf3703fc.png";